import { render } from "./AddAccessory.vue?vue&type=template&id=6bd0cf19"
import script from "./AddAccessory.vue?vue&type=script&lang=js"
export * from "./AddAccessory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__